import * as React from "react"

import { cn } from "@/lib/utils"

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  heading: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
}

export function EmptyState({
  className,
  icon,
  heading,
  description,
  action,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center h-64 text-gray-400",
        className
      )}
      {...props}
    >
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        {icon}
      </div>
      <p className="font-medium mb-2">{heading}</p>
      {description ? (
        <p className="text-sm text-gray-400 mb-4 text-center">{description}</p>
      ) : null}
      {action}
    </div>
  )
}
